import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <span className="font-heading text-[8rem] md:text-[12rem] font-black text-background-200 select-none pointer-events-none leading-none">
        404
      </span>
      <div className="relative z-10 -mt-10 md:-mt-16 flex flex-col items-center">
        <div className="flex items-center gap-1">
          <span className="font-heading text-2xl font-extrabold text-primary-500 leading-none">91</span>
          <span className="font-heading text-2xl font-extrabold text-foreground-950 leading-none">.con</span>
        </div>
        <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-4">页面走丢了</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono break-all">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-600">该页面不存在或已被移动，去首页继续浏览精彩内容吧。</p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-7">
          <Link
            to="/"
            className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
          >
            <i className="ri-home-4-line text-lg" />
            返回首页
          </Link>
          <Link
            to="/videos"
            className="h-11 px-6 rounded-md border border-background-300 text-foreground-900 text-sm font-semibold hover:border-primary-500/60 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
          >
            <i className="ri-film-line text-lg" />
            浏览视频
          </Link>
        </div>
      </div>
    </div>
  );
}